import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import tobaccoProductionsApi from '../../../api/tobaccoProductionsApi';

// ---------------------------------------------------------------------

interface ProductionParams {
  startDate: string;
  endDate: string;
}

const REDUCER_NAME = 'tobaccoProduction';

export const GetConveyorTobaccoProduction = createAsyncThunk(
  `${REDUCER_NAME}/getConveyorTobaccoProduction`,
  async (params: ProductionParams, thunkAPI) => {
    params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await tobaccoProductionsApi.get(params);

    if (res.status === 200) {
      return { ...res.data?.data, startDate: params.startDate, endDate: params.endDate };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetTobaccoConveyorSteps = createAsyncThunk(
  `${REDUCER_NAME}/getTobaccoConveyorSteps`,
  async (__, thunkAPI) => {
    const res = await tobaccoProductionsApi.getTobaccoConveyorStepsV2();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
